import { render, staticRenderFns } from "./recent.vue?vue&type=template&id=76237bf2&scoped=true"
import script from "./recent.vue?vue&type=script&setup=true&lang=js"
export * from "./recent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./recent.vue?vue&type=style&index=0&id=76237bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76237bf2",
  null
  
)

export default component.exports